import React, { useRef, forwardRef, useImperativeHandle, useMemo } from 'react';
import { pickBy } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'qs';

import { IS_LOCAL } from '../../../../utils/config';

const Frame = forwardRef(({ params }, ref) => {
  const frameRef = useRef(null);

  const onLoadFrame = () => {
    frameRef.current?.contentWindow?.document?.addEventListener('click', (event) => {
      const linkElement = event?.target?.closest('a');
      if (linkElement?.closest('.guides__article-content')) {
        event.preventDefault();
        event.stopPropagation();
        const type = linkElement.getAttribute('data-type');
        const href = linkElement.getAttribute('href');
        const target = linkElement.getAttribute('target');
        if (!type && href && href !== '# ') {
          if (target === '_blank') {
            window.open(href, '_blank');
          } else {
            window.location.href = href;
          }
        }
      }
    });
  };

  useImperativeHandle(ref, () => ({
    sendMessage(data) {
      frameRef.current?.contentWindow?.postMessage({ type: 'guides', data }, '*');
    },
    frameRef: frameRef.current,
  }));

  const prepareLink = useMemo(() => {
    const query = pickBy({ pn: params?.anchor ? undefined : window.location.pathname, anchor: params?.anchor });
    return IS_LOCAL ? `/guides?${qs.stringify(query)}` : `/admin/guides?${qs.stringify(query)}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <iframe ref={frameRef} src={prepareLink} onLoad={() => onLoadFrame()} title="Guides" width="100%" height="480px" style={{ border: 'none' }} />
  );
});

Frame.propTypes = {
  params: PropTypes.object,
};

export default Frame;
